import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// Import UI Components
import { Icon, Tooltip } from '@geneui/components';
// Import Hooks
import { usePartnerDateFormats } from 'hooks';
// Import Helpers
import { customMomentWithoutTimezoneConversion } from 'services/Helpers';
// Import Enums
import { CampaignExecutionStatusEnum } from 'enums';
// Import Constants
import { l } from 'constants/common';
// Import Styles
import styles from './campaignActivityStatus.module.scss';

interface Props {
    Status: string;
    StatusEnum: CampaignExecutionStatusEnum;
    EndDate: Nullable<string>;
    IsPreCalculate: boolean;
}

const CampaignActivityStatus: React.FC<Props> = (props) => {
    const { Status, StatusEnum, IsPreCalculate, EndDate } = props;
    const { t } = useTranslation();
    const { partnerDateTimeFormat } = usePartnerDateFormats();

    const endDate = useMemo(
        () => customMomentWithoutTimezoneConversion(EndDate).format(partnerDateTimeFormat),
        [EndDate, partnerDateTimeFormat],
    );

    const tooltipText = useMemo(() => {
        switch (StatusEnum) {
            case CampaignExecutionStatusEnum.PreparingSegment:
            case CampaignExecutionStatusEnum.Sending:
                return t(l.PreCalculationInProgress);
            case CampaignExecutionStatusEnum.Success:
                return t(l.PreCalculationCompleted, { date: endDate });
            case CampaignExecutionStatusEnum.Fail:
                return t(l.PreCalculationFailed);
            case CampaignExecutionStatusEnum.Stop:
                return t(l.PreCalculationStopped);
            default:
                return '';
        }
    }, [StatusEnum, endDate, t]);

    return (
        <div className={styles.container}>
            {Status}

            {IsPreCalculate && (
                <Tooltip text={tooltipText} position="top">
                    <Icon type="bc-icon-calculator" />
                </Tooltip>
            )}
        </div>
    );
};

export default memo(CampaignActivityStatus);
